import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Totes_ds_get_tote_containersService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { lookupCode?: string, warehouseId?: number }): 
  Promise<{ result: { Id?: number, ContainerTypeId?: number, LookupCode?: string, StatusId?: number, WarehouseId?: number, Status?: { Name?: string }, Type?: { Description?: string, Name?: string }, Warehouse?: { Name?: string } }[] }> 
  {
    let $url = `${environment.backendUrl}api/Totes/datasources/ds_get_tote_containers/get`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { lookupCode?: string, warehouseId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ContainerTypeId?: number, LookupCode?: string, StatusId?: number, WarehouseId?: number, Status?: { Name?: string }, Type?: { Description?: string, Name?: string }, Warehouse?: { Name?: string } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/Totes/datasources/ds_get_tote_containers/getList`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { lookupCode?: string, warehouseId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ContainerTypeId?: number, LookupCode?: string, StatusId?: number, WarehouseId?: number, Status?: { Name?: string }, Type?: { Description?: string, Name?: string }, Warehouse?: { Name?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/Totes/datasources/ds_get_tote_containers/getByKeys`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      lookupCode?: string, warehouseId?: number    }) {
      return false;
    }
}
